export default function getContactName({ eligibleFriends, selectedContactId }) {
  if (selectedContactId === undefined) {
    return 'Your contact';
  }
  const friend = eligibleFriends.find(({ id }) => id === selectedContactId);
  if (friend) {
    return friend.name || 'Your contact';
  }
  return 'Your contact';
}